import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d46c19d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, null, -1))
const _hoisted_3 = { class: "last-block" }
const _hoisted_4 = {
  key: 0,
  class: "last-block__text"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("終"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "お"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("残"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "のこ"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("時間"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "じかん"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("分"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "ふん"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_11 = {
  key: 1,
  class: "last-block__text"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("終"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "お"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("残"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "のこ"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("時間"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "じかん"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("秒"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "びょう"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))
const _hoisted_18 = { class: "last-block__note" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("解答"),
  /*#__PURE__*/_createElementVNode("rt", null, "かいとう")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("見直"),
  /*#__PURE__*/_createElementVNode("rt", null, "みなお")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("場合"),
  /*#__PURE__*/_createElementVNode("rt", null, "ばあい")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("見直"),
  /*#__PURE__*/_createElementVNode("rt", null, "みなお")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("番号"),
  /*#__PURE__*/_createElementVNode("rt", null, "ばんごう")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("押"),
  /*#__PURE__*/_createElementVNode("rt", null, "お")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("終了"),
  /*#__PURE__*/_createElementVNode("rt", null, "しゅうりょう")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("場合"),
  /*#__PURE__*/_createElementVNode("rt", null, "ばあい")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("押"),
  /*#__PURE__*/_createElementVNode("rt", null, "お")
], -1))
const _hoisted_31 = { class: "review" }
const _hoisted_32 = { rowspan: "2" }
const _hoisted_33 = { class: "part-title" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "PART", -1))
const _hoisted_35 = { class: "number" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "last-block__btns" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "おわる", -1))
const _hoisted_40 = [
  _hoisted_39
]

import {inject, ref} from "vue"
import { useRoute, useRouter } from 'vue-router'
import Timer from '@/components/parts/Timer.vue'
import { appKey, examKey } from "@/main";
import { PartWithAnswers, SessionData } from "@/store/exam";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Confirm',
  emits: ['overridePageName'],
  setup(__props) {

const route = useRoute();
const router = useRouter();

const app = inject(appKey);
const exam = inject(examKey);


const group = route.params.group;
const timeRemaining = ref<number>(0);
const timeInitial = ref<number>(0);
const session = ref<SessionData>();
const partsReading = ref<PartWithAnswers[]>([]);

const gakken = exam?.isGakken();

const init = async() => {
  if (!exam) return;
  session.value = await exam.session();
  const questions = await exam.questions();
  timeRemaining.value = session.value.readingTimeRemaining;
  timeInitial.value = session.value.readingTimeRemaining;
  partsReading.value = await exam.createPartsListWithAnswers(questions.reading);
  console.log(partsReading.value);
  exam.setReachedLastQuestion();
}
init();

const review = async(pageNumber: number) => {
  if (!session.value) return;
  session.value.readingTimeRemaining = timeRemaining.value;
  if (!exam) return;
  await exam.updateSession(session.value);
  router.replace(`/cbt/${group}/reading/${pageNumber}`);
}

const updateTimer = async(_timeRemaining: number) => {
  timeRemaining.value = _timeRemaining;
}
const timeover = async() => {
  if (!session.value) return;
  await exam?.readingEnd();
  app?.stopAudio();
  router.replace(`/cbt/${group}/end`);
}

const end = async() => {
  await exam?.readingEnd();
  router.replace(`/cbt/${group}/end`);
}

const demoPrev = async () => {
  if (!session.value) return;
  session.value.readingTimeRemaining = timeRemaining.value;
  if (!exam) return;
  await exam.updateSession(session.value);
  const questions = await exam?.questions();
  if (!questions) return;
  const lastPage = questions.reading.pages.length - 1;
  router.replace(`/cbt/${group}/reading/${lastPage}`);
}
const demoNext = () => router.replace(`/cbt/${group}/end`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("header", _hoisted_1, [
        _hoisted_2,
        (timeInitial.value)
          ? (_openBlock(), _createBlock(Timer, {
              key: 0,
              onTimeover: timeover,
              onUpdate: updateTimer,
              initTimeRemaining: timeRemaining.value
            }, null, 8, ["initTimeRemaining"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          (timeRemaining.value >= 60)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                (_ctx.$route.params.mode == 'end')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createTextVNode("テストはこれで"),
                      _hoisted_6,
                      _createTextVNode("わりです。"),
                      _hoisted_7
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_8,
                _createTextVNode("り"),
                _hoisted_9,
                _createTextVNode(_toDisplayString(Math.ceil(timeRemaining.value / 60)), 1),
                _hoisted_10,
                _createTextVNode("です。 ")
              ]))
            : _createCommentVNode("", true),
          (timeRemaining.value < 60)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                (_ctx.$route.params.mode == 'end')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode("テストはこれで"),
                      _hoisted_13,
                      _createTextVNode("わりです。"),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_15,
                _createTextVNode("り"),
                _hoisted_16,
                _createTextVNode(_toDisplayString(Math.ceil(timeRemaining.value)), 1),
                _hoisted_17,
                _createTextVNode("です。 ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_18, [
            _hoisted_19,
            _createTextVNode("を"),
            _hoisted_20,
            _createTextVNode("したい"),
            _hoisted_21,
            _createTextVNode("は、"),
            _hoisted_22,
            _createTextVNode("したい"),
            _hoisted_23,
            _hoisted_24,
            _createTextVNode("を"),
            _hoisted_25,
            _createTextVNode("してください。"),
            _hoisted_26,
            (_unref(gakken))
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                  _hoisted_28,
                  _createTextVNode("する"),
                  _hoisted_29,
                  _createTextVNode("は、「おわる」ボタンを"),
                  _hoisted_30,
                  _createTextVNode("してください。 ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("table", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partsReading.value, (part) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: part.number
              }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, _toDisplayString(part.number), 1)
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(part.answers, (answer, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: index,
                      class: "question-number"
                    }, [
                      _createElementVNode("label", {
                        onClick: ($event: any) => (review(answer.page))
                      }, _toDisplayString(answer.questionNumber), 9, _hoisted_36)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(part.answers, (answer, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["answer", { answered: answer.answer !== 0 }]),
                        onClick: ($event: any) => (review(answer.page))
                      }, [
                        (answer.answer !== 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(answer.answer), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_37)
                    ]))
                  }), 128))
                ])
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_38, [
            (_unref(gakken))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (end())),
                  class: "m-btn"
                }, _hoisted_40))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext
    })
  ], 64))
}
}

})